import React, { useEffect, useState } from "react";
import {
  Box, Typography, Button, Grid,
  FormControl, InputLabel, Select, MenuItem,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import { fetchActionsForActionPlan, fetchActionPlan, addActionToActionPlan } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";

export default function ActionPlanActionAddPage() {
  const { businessDomainId, businessUnitId, actionPlanId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  const basePath = `/strategy/${businessDomainId}/business-units/${businessUnitId}/action-plans/${actionPlanId}`;

  const [actions, setActions] = useState([]);
  const [registeredActionIds, setRegisteredActionIds] = useState([]);
  const [selectedAction, setSelectedAction] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const [list, plan] = await Promise.all([
          fetchActionsForActionPlan(actionPlanId),
          fetchActionPlan(actionPlanId),
        ]);
        setActions(Array.isArray(list) ? list : []);
        const associated = plan?.associatedActions || [];
        setRegisteredActionIds(associated.map((a) => a.actionId));
      } catch (e) { notify.apiError(e); }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actionPlanId]);

  const handleActionChange = (e) => {
    const found = actions.find((a) => a.actionId === e.target.value);
    setSelectedAction(found || null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedAction) {
      notify.error(t("actionPlan.action.select.required"));
      return;
    }
    if (registeredActionIds.includes(selectedAction.actionId)) {
      notify.error(t("actionPlan.action.error.duplicate"));
      return;
    }
    try {
      await addActionToActionPlan(actionPlanId, {
        actionId:       selectedAction.actionId,
        actionName:     selectedAction.actionName,
        departmentId:   selectedAction.departmentId,
        departmentName: selectedAction.departmentName,
      });
      notify.success(t("message.create.success"));
      navigate(`${basePath}/actions`);
    } catch (err) { notify.apiError(err); }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>{t("actionPlan.action.add.title")}</Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>

          {/* アクション選択 */}
          <Grid size={12}>
            <FormControl fullWidth required>
              <InputLabel>{t("actionPlan.action.name")}</InputLabel>
              <Select
                value={selectedAction?.actionId || ""}
                onChange={handleActionChange}
                label={t("actionPlan.action.name")}
              >
                {actions.map((a) => (
                  <MenuItem key={a.actionId} value={a.actionId}>
                    {a.actionName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

        </Grid>
        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="contained" type="submit">{t("common.add")}</Button>
          <Button variant="outlined" onClick={() => navigate(`${basePath}/actions`)}>{t("common.cancel")}</Button>
        </Box>
      </Box>
    </Box>
  );
}
